import { render } from "./MessageChat.vue?vue&type=template&id=2f5ffce9&scoped=true"
import script from "./MessageChat.vue?vue&type=script&lang=js"
export * from "./MessageChat.vue?vue&type=script&lang=js"

import "./MessageChat.vue?vue&type=style&index=0&id=2f5ffce9&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5ffce9"]])

export default __exports__